/**
 * Centralized platform configuration accessor.
 * Defaults to 1bpay if not properly initialized.
 */
export const platform = window.lacasaeConfig || {
  serviceName: '1bpay',
  primaryColor: '#191B23',
  secondaryColor: '#00E2A2',
  hasWallet: false,
};

// Ensure feeDashboardConfig is initialized
if (!platform.feeDashboardConfig) {
  platform.feeDashboardConfig = {
    hiddenCategories: ['giftcard', 'platform'],
    hiddenOperations: []
  };
}

// Apply platform specific fee visibility
if (['1xpay', '1bpay'].includes(platform.serviceName)) {
  platform.feeDashboardConfig.hiddenOperations.push('withdrawalAffiliation');
}

// Derive logo path from serviceName
const logoMap = {
  '1bpay': '/images/logos/1bpay.svg',
  '1xpay': '/images/logos/1xpay.png',
  'kingrecharges': '/images/logos/kingrecharge.svg'
};

platform.logo = logoMap[platform.serviceName] || '/logo.svg';

export const hasWallet = platform.hasWallet;
export const serviceName = platform.serviceName;
export const logo = platform.logo;

export default platform;
